import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Prismic from 'prismic-javascript';
import styled from 'styled-components';
import MetaTags from 'react-meta-tags';
import { RichText } from 'prismic-reactjs';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 92px;
  .wrapper {
    align-items: flex-start;
    flex-wrap: wrap;

    .products {
      display: flex;
      flex-wrap: wrap;
    }

    a {
      background: #fff;
      display: flex;
      text-decoration: none;
      color: #40403F;
      margin-left: 17px;
      flex-wrap: wrap;
      align-items: flex-start;
      width: calc(33.3% - 13px);
      margin-bottom: 20px;
      
      &:first-child {
        margin-left: 0;
      }

      .image {
        width: 100%;
        height: 354px;
        position: relative;
        overflow: hidden;

        span {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-size: cover;
          background-position: center;
          transition: all 0.3s;
        }
      }

      .text {
        padding: 24px 25px;

        .title {
          font: italic bold 46px 'Times new roman';
          margin-bottom: 10px;
          display: block;

          h1 {
            font: italic bold 46px 'Times new roman';
            margin: 0;
          }
        }

        p {
          font-size: 14px;
        }

        .button {
          background: #F1A857;
          color: #fff;
          height: 50px;
          display: block;
          margin-top: 22px;
          line-height: 50px;
          text-align: center;
          transition: all 0.3s;
        }
      }

      &:hover {
        .image span {
          transform: scale(1.05);
        }

        .button {
          background: #E59134;
        }
      }

      @media (max-width: 1024px) {
        width: calc(50% - 9px);

        &:nth-child(2n+1) {
          margin-left: 0;
        }
      }

      @media (max-width: 789px) {
        width: 100%;
        margin-left: 0;
      }
    }
  }
`

class Certificates extends Component {
  state = {
    content: {},
    language: '',
    section: '',
    tipo: '',
    url: ''
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({tipo: this.props.match.url.match('compensados') ? 'compensados' : 'mdf', section: this.props.match.params.section, language: language, url: this.props.match.url});
    this.getContent();
    this.getScroll();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      this.state.url !== this.props.match.url ||
      this.state.language !== language
    ) {
      window.scrollTo(0, 0)
      this.setState({tipo: this.props.match.url.match('compensados') ? 'compensados' : 'mdf', section: this.props.match.params.section, language: language, url: this.props.match.url});
      this.getContent();
      this.getScroll();
    }
  }

  getContent = () => {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchContent = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.pagina_produtos.tipo', this.props.match.url.match('compensados') ? 'compensados' : 'mdf'),
        {lang: language}
      )
      if (response.results[0]) {
        this.setState({content: response.results[0].data});
      }
    }
    fetchContent();
  }

  getScroll = () => {
    if (this.state.section !== '' && document.querySelector(`#${this.props.match.params.section}`)) {
      window.scrollTo(0, document.querySelector(`#${this.props.match.params.section}`).offsetTop - 148)
    }
  }

  slugify = (string) => {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')  
  
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-')
      .replace(p, c => b.charAt(a.indexOf(c)))
      .replace(/&/g, '-and-')
      .replace(/[^\w]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
  }

  render = () => {
    const { tipo } = this.state;
    const { language } = this.context;
    let home = ''
    let produtos = ''
    let certificados = ''
    let text = ''
    switch (language) {
      case 'pt-br':
        home = 'Início'
        produtos = 'Produtos'
        certificados = 'Certificados'
        text = 'Todos os compensados Guararapes possuem certificados que atestam a grande qualidade e conformidade para uso em construções na Europa, Reino Unido e América do norte.'
        break;
      case 'en-us':
        home = 'Home'
        produtos = 'Products'
        certificados = 'Certificates'
        text = 'All Guararapes plywood have certificates that attest to the great quality and conformity for use in constructions in Europe, United Kingdom and North America'
        break;
      case 'es-es':
        home = 'Inicio'
        produtos = 'Produtos'
        certificados = 'Certificados'
        text = 'Todos los contrachapados de Guararapes cuentan con certificados que dan fe de la gran calidad y conformidad para su uso en construcciones en Europa, Reino Unido y Norteamérica'
        break;
      default:
    }
    return (
      <div id="certificados">
        <MetaTags>
          <title>{ this.state.content.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.content.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.content.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ produtos }>
          <div>
            <Link to="/">{ home }</Link>
            <Link to="/produtos">{ produtos }</Link>
          </div>
        </Breadcrumbs>
        <main id="content">
          <Container>
            <div className={ ['wrapper', 'flex', tipo].join(' ') }>
            {
              this.state.content.produtos && this.state.content.produtos.map((item, index) => {
                return (
                  <a href={ item.botao.url } rel="noopener noreferrer">
                    <div className="image">
                      <span style={ item.banner && { backgroundImage: "url(" + item.banner.url + ")" } }></span>
                    </div>
                    <div className="text">
                      <span className="title">
                        { RichText.render(item.nome) }
                      </span>
                      { RichText.render(item.conteudo) }
                      <span className="button">
                      { item.texto_botao }
                      </span>
                    </div>
                  </a>
                )
              })
            }
            {
              (tipo === 'compensados') && (
                <a href="/certificados/compensados" rel="noopener noreferrer">
                  <div className="image">
                    <span style={ { backgroundImage: "url(/images/certificates.jpeg)" } }></span>
                  </div>
                  <div className="text">
                    <span className="title">
                      { certificados }
                    </span>
                    <p>
                      { text }
                    </p>
                    <span className="button">
                      Certificados
                    </span>
                  </div>
                </a>
              )
            }
            </div>
          </Container>
        </main>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Certificates.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Certificates.contextType = LanguageContext;

export default Certificates;
